import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ORGANIZATION/DASHBOARD';

export const {
    action: fetchOccupancyData,
    success: fetchOccupancyDataSuccess,
    failed: fetchOccupancyDataFailed,
} = createAction(`${domain}/FETCH_OCCUPANCY_DATA`, (organizationId, year) => ({organizationId, year}));

export const {
    action: fetchLeaversAndJoiners,
    success: fetchLeaversAndJoinersSuccess,
    failed: fetchLeaversAndJoinersFailed,
} = createAction(`${domain}/FETCH_LEAVERS_AND_JOINERS`, (organizationId, year) => ({organizationId, year}));

export const {
    action: fetchEnrolledData,
    success: fetchEnrolledDataSuccess,
    failed: fetchEnrolledDataFailed,
} = createAction(`${domain}/FETCH_ENROLLED_DATA`, (organizationId, year) => ({organizationId, year}));

export const {
    action: fetchRegisteredEmployees,
    success: fetchRegisteredEmployeesSuccess,
    failed: fetchRegisteredEmployeesFailed,
} = createAction(`${domain}/FETCH_REGISTERED_EMPLOYEES`, (organizationId, year) => ({organizationId, year}));

export const {
    action: fetchEmployeeSickDays,
    success: fetchEmployeeSickDaysSuccess,
    failed: fetchEmployeeSickDaysFailed,
} = createAction(`${domain}/FETCH_EMPLOYEE_SICK_DAYS`, (organizationId, year) => ({organizationId, year}));

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(`${domain}/FETCH_ALL`, (organizationId, year, refresh, revenueFilter) => ({
    organizationId,
    year,
    refresh,
    revenueFilter,
}));

export const {action: setYear} = createAction(`${domain}/SET_YEAR`, year => ({year}));

export const {action: filterRevenue} = createAction(
    `${domain}/FILTER_REVENUE`,
    (organizationId, year, revenueFilter) => ({organizationId, year, revenueFilter}),
);
